import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { StickyConfig, StickyLinkGroup, StickyLink, DEFAULT_STICKY_CONFIG, StickyLinkType, ConfigMeta } from '../sticky-tabs/sticky-tabs.component';

@Component({
  selector: 'pla-main-nav-chips',
  templateUrl: './main-nav-chips.component.html',
  styleUrls: ['./main-nav-chips.component.scss']
})
export class MainNavChipsComponent implements OnInit {

  @Input() public backLink: string | undefined;
  @Input() public useSpacing: boolean = true;
  @Input() public rightPadding: boolean = true;
  @Input() public defaultConfig: boolean = true;
  @Input() public config: ConfigMeta = {
    ...DEFAULT_STICKY_CONFIG,
    sticky: false,
    backgroundColour: 'rgba(13,13,13,0.23)',
    defaultStyle: {
      fontWeight: 'fw-light',
      borderWidth: 1,
      borderColour: '#fff',
      textColour: '#fff',
      backgroundColour: 'transparent'
    },
    selectedStyle: {
      fontWeight: 'fw-light',
      borderWidth: 1,
      borderColour: '#fff',
      textColour: '#2f2f2f',
      backgroundColour: '#fff'
    }
  };

  public stickyLinkConfig: StickyConfig = new StickyConfig([
    new StickyLinkGroup(
      [
        new StickyLink('Home', '/buy', true, StickyLinkType.OUT_OF_PAGE),
        new StickyLink('Initials', '/initials-search', false, StickyLinkType.OUT_OF_PAGE),
        new StickyLink('Dateless', '/dateless-search', false, StickyLinkType.OUT_OF_PAGE),
        new StickyLink('Build-Your-Own', '/byo-search', false, StickyLinkType.OUT_OF_PAGE),
        // Two-chip release pattern: each chip points to its own series page
        // and matches only that route. 26 and 76 are both commercially
        // active right now (26 plates still selling daily, 76 launched
        // 2026-05-06). The broad `/new-release` routeMatch the 26 chip
        // previously used mis-highlighted "26 Reg" when the user was on
        // /new-release/76 — now each chip activates only on its own page.
        new StickyLink('26 Reg', '/plates/26-reg', false, StickyLinkType.OUT_OF_PAGE, '/plates/26-reg'),
        new StickyLink('76 Reg', '/plates/76-reg', false, StickyLinkType.OUT_OF_PAGE, '/plates/76-reg')
      ],
    ),
    new StickyLinkGroup([
      new StickyLink('Ultimate Names', '/names', false, StickyLinkType.OUT_OF_PAGE),
      new StickyLink('Number 1\'s', '/number-1', false, StickyLinkType.OUT_OF_PAGE),
      new StickyLink('Under £200', '/under-200', false, StickyLinkType.OUT_OF_PAGE),
    ]),
    // new StickyLinkGroup([
    //   new StickyLink('Sell', '/sell', false, StickyLinkType.OUT_OF_PAGE)
    // ]),
    // new StickyLinkGroup([
    //   new StickyLink('Compare Prices', '/compare', false, StickyLinkType.OUT_OF_PAGE)
    // ]),
      new StickyLinkGroup([
      new StickyLink('Plate Viewer', '/plate-viewer', false, StickyLinkType.OUT_OF_PAGE)
    ]), new StickyLinkGroup([
        new StickyLink('About Us', '/about', false, StickyLinkType.OUT_OF_PAGE)
      ]),
    // new StickyLinkGroup([
    //   new StickyLink('Blogs', '/blog', false, StickyLinkType.OUT_OF_PAGE)
    // ])
  ],
    new EventEmitter<void>(),
    this.config
  );

  constructor() { }

  ngOnInit(): void {
    this.stickyLinkConfig = { ...this.stickyLinkConfig, metaData: this.defaultConfig === true ? DEFAULT_STICKY_CONFIG : this.config };
    this.SetActivePage();
  }

  private SetActivePage(): void {
    const path = window.location.pathname;
    this.stickyLinkConfig.groups = this.stickyLinkConfig.groups.map(g => {
      g.links = g.links.map(l => {
        l.active = path.startsWith(l.routeMatch);
        if (l.anchor === '/buy' && (path.startsWith('/landing') || path === '/')) l.active = true;
        return l;
      });
      return g;
    })
  }

}
